// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__YlHkc","addWidgetButton":"Header_addWidgetButton__24ayV","dashboardTabs":"Header_dashboardTabs__3Zagj","active":"Header_active__3_GBn"};